<template>
	<div>
	<h1 class="mb-4">{{ title }}</h1>
		<v-filters
			class="mb-4"
			v-bind="{
				filters: urlFilters,
				clientsTariffs: CLIENTS_TARIFFS,
				loading
			}"
			@update-filters="updateUrl"
		/>
		<v-btn
			@click="downloadCsv"
		>
			Экспорт CSV
		</v-btn>
		<v-data-table
			class="clients-statistics-table"
			:headers="headers"
			:items="tableItems"
			:loading="loading.table"
			disable-pagination
			hide-default-footer
			fixed-header
			height="calc(100vh - 225px)"
		>
			<template v-slot:header.data_unit="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Сумма по всем инструментам
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.unit_positions="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во заданий * кол-во запросов * кол-во регионов
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.unit_indexation="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во заданий * кол-во url
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.unit_ws="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во заданий * кол-во запросов * кол-во типов частотки
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.ws_history="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во заданий * кол-во запросов
        </span>
					</v-tooltip>
				</div>
			</template>
			<template v-slot:header.ws_ads="{ header }">
				<div class="d-flex align-center justify-center">
					<span>{{ header.text }}</span>

					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-icon
								small
								class="ml-1"
								v-bind="attrs"
								v-on="on"
							>
								mdi-information-outline
							</v-icon>
						</template>

						<span>
          Кол-во заданий * кол-во запросов
        </span>
					</v-tooltip>
				</div>
			</template>
		</v-data-table>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import filters from './filters.vue'
import { validateFilterFromOptions } from '@/function/validateFilter'
import updateUrlMixin from '@/mixins/updateUrlMixin'
import { NOTIFY_STATUS } from '@/const'
import errors from '@/store/errors'

const CLIENTS_TARIFFS = [
	{ text: 'Не выбран', value: 0 },
	{ text: 'Base', value: 1 },
	{ text: 'Pro', value: 2 },
	{ text: 'Premium', value: 3 },
	{ text: 'Специальный', value: 4 },
	{ text: 'Enterprise', value: 5 },
	{ text: 'Demo', value: 6 },
	{ text: 'Position', value: 7 },
	{ text: 'Position Plus', value: 8 }
]

export default {
	name: 'clientsManualToolsStatistics',
	components: {
		'v-filters': filters
	},
	mixins: [updateUrlMixin],

	metaInfo () {
		return {
			title: this.title
		}
	},

	data () {
		return {
			title: 'Лимиты инструментов по клиентам',
			CLIENTS_TARIFFS,
			monthMenu: false,
			selectedMonth: null,
			clientSearch: '',
			filters: {
				only_active_clients: 1
			},
			showInactive: false,
			headers: [
				{
					text: 'ID клиента',
					value: 'client_id',
					align: 'center',
					divider: true
				},
				{
					text: 'Имя клиента',
					value: 'name',
					align: 'center',
					divider: true
				},
				{
					text: 'Тариф',
					value: 'tariff',
					align: 'center',
					divider: true
				},
				{
					text: 'Data-unit',
					value: 'data_unit',
					align: 'center',
					divider: true
				},
				{
					text: 'Unit позиции / слепок выдачи',
					value: 'unit_positions',
					align: 'center',
					divider: true
				},
				{
					text: 'Unit индексация',
					value: 'unit_indexation',
					align: 'center',
					divider: true
				},
				{
					text: 'Unit WS',
					value: 'unit_ws',
					align: 'center',
					divider: true
				},
				{
					text: 'Unit ws историчность',
					value: 'ws_history',
					align: 'center',
					divider: true
				},
				{
					text: 'Unit ws ads',
					value: 'ws_ads',
					align: 'center',
					divider: true
				}
			],
			loading: {
				table: true,
				clients: true
			}
		}
	},

	computed: {
		...mapState({
			clientsManualToolsStatisticsData: state => state.clientsManualToolsStatistics.clientsManualToolsStatisticsData?.items || [],
			clients: state => state.clients
		}),

		tableItems () {
			return this.clientsManualToolsStatisticsData.map(item => {
				return {
					...item,
					client_id: item.client_id,
					name: item.name,
					tariff: item.tarif,
					data_unit: item.data_unit,
					unit_positions: item.unit_positions,
					unit_indexation: item.unit_indexation,
					unit_ws: item.unit_ws,
					ws_history: item.ws_history,
					ws_ads: item.ws_ads
				}
			})
		},

		urlFilters () {
			const {
				client_ids,
				tariff_id,
				month,
				only_active_clients
			} = this.$route.query

			return {
				clientIds: validateFilterFromOptions(Array.isArray(client_ids) ? client_ids : [client_ids], this.clients, [], true, true),
				tariffId: tariff_id ? Number(tariff_id) : null,
				month: month || undefined,
				only_active_clients: only_active_clients ?? 1,
				filters
			}
		}
	},

	async created () {
		try {
			await this.getClients()
		} catch (_) {
			this.$notify({
				type: NOTIFY_STATUS.ERROR,
				title: errors.GET_DATA
			})
		} finally {
			this.loading.clients = false
		}
		await this.initDataTable()
	},

	watch: {
		async '$route.query' () {
			await this.initDataTable()
		}
	},

	methods: {
		...mapActions({
			getClientsManualToolsStatisticsData: 'clientsManualToolsStatistics/getClientsManualToolsStatisticsData',
			getClients: 'getClients'
		}),

		async initDataTable () {
			const {
				clientIds,
				tariffId,
				month,
				only_active_clients
			} = this.urlFilters

			this.loading.table = true
			await this.getClientsManualToolsStatisticsData({
				query: {
					client_ids: clientIds,
					tariff_id: tariffId || undefined,
					month: month || undefined,
					only_active_clients: only_active_clients ?? 1
				}
			})
			this.loading.table = false
		},

		downloadCsv () {
			const url = new URL('api/v1/clients/limits/manual-tools', this.$store.state.config.api.hqsw)

			const {
				clientIds,
				tariffId,
				month,
				onlyActiveClients
			} = this.urlFilters

			const params = new URLSearchParams()

			;(clientIds ?? []).forEach((id, index) => {
				params.append(`client_ids[${index}]`, id)
			})

			tariffId && params.append('tariff_id', tariffId)
			month && params.append('month', month)
			onlyActiveClients && params.append('only_active_clients', onlyActiveClients ?? 1)
			params.append('download', 1)

			url.search = params.toString()

			const link = document.createElement('a')
			link.href = url.toString()

			document.body.appendChild(link)
			link.click()
			link.remove()
		}
	}
}
</script>

<style >
.clients-statistics-table {
	margin-top: 24px;
	border-top: 1px solid rgba(0,0,0,.12);
}
</style>
